import { get, post, put, destroy } from './config';

const User = {
    get: (config) =>
        get('/v1/users', config),
    registerNew: (data) =>
        post('/v1/users/register', data),
    registerCN: (data) =>
        post('/v1/cnusers', data),
    update: (data, config) =>
        put('/v1/users/update', data, config),
    getCoordinate: (number) =>
        get(`v1/orders/positions/list?orderNo=${number}`),
    getHistory: (id) => 
        get(`v1/orders/${id}/states`),
    changePassword: (data) =>
        post('/v1/users/change-password', data),
    getDriverById: (driverId) =>
        get(`v1/users/by-${driverId}`),
    isActive: () =>
        get(`v1/users/drivers/isactive`),
    forgotPassword: (email) => 
        post('/v1/users/forgot-password', {email} ),
    checkСodePassword: (code) => 
        post('/v1/users/reset-password/check-code', {code} ),
    resetPassword: (data) =>
        post('/v1/users/reset-password', data),
    sendConfirmationEmail: (email) =>
        post('/v1/users/email/send-code', { email }),
    checkCodeEmail: (code, email) =>
        post('/v1/users/email/confirm', { code, email }),
    updateStep: (step) =>
        post('/v1/users/client/update-step', { step }),
    updateEmail: (email) =>
        post('/v1/users/update-email', { email }),
    check: (type, value) =>
        post(`/v1/users/check/${type}`, { [type]: value }),
    addPartner: (data) =>
        post('/v1/expeditor', data),
    getCodeInfo: (code) =>
        get(`/v1/partners/${code}`),
    getOrderLimit: () =>
        get('/v1/orders/limit'),
    getAirOrderLimit: () =>
        get('/v1/airorders/limit'),
    getUserLimit: () =>
        get('/v1/users/limit'),
    registerInvitationExpeditor: (clientId, code, data) =>
        post(`/v1/users/partner/register/${clientId}/${code}`, data),
    acceptPartnerInvitation: (code) =>
        post(`/v1/partners/invitation/accept/${encodeURIComponent(code)}`, null, {
            skipAuth: true,
        }),
    saveFcmToken: (userId, token) =>
        post(`/v1/users/driver/${userId}/${token}`),
    guestLogin: (orderId) =>
        post('/v1/users/client/guest-login', { orderId }),
    getUsersByCompany: (companyId, config) =>
        get(`/v1/users/company/by-${companyId}`, config),
    generateTelegramCode: () =>
        post('/v1/users/telegram/generate-code'),
}

export default User;
